import React, { cloneElement, useCallback } from 'react'
import { WidgetBody, WidgetCard } from './BaseWidget.styles'
import type { BaseWidgetProps } from './BaseWidget.types'

import { ReactComponent as ArrowNext } from 'assets/fill_back_arrow.svg'

import { Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { COLORS } from 'styles/colors'
import Preloader from 'ui/Preloader'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

export const BaseWidget: React.FC<BaseWidgetProps> = ({
	children,
	icon,
	path,
	pathLable,
	isLoading,
	title,
}) => {
	const navigate = useNavigate()
	const navigateToPath = useCallback(() => {
		navigate(path)
	}, [navigate, path])

	return (
		<WidgetCard>
			{title && (
				<TypographyPrimary16Bold mb={'24px'}>{title}</TypographyPrimary16Bold>
			)}
			{isLoading ? <Preloader /> : <WidgetBody>{children}</WidgetBody>}

			<Stack direction='row' alignItems='center' justifyContent='space-between'>
				{icon ? (
					cloneElement(icon, {
						width: '16px',
						height: '16px',
					})
				) : (
					<div></div>
				)}
				<Stack
					direction='row'
					gap='4px'
					onClick={navigateToPath}
					sx={{ cursor: 'pointer' }}
				>
					{pathLable && <TypographySecondary>{pathLable}</TypographySecondary>}
					{path && (
						<ArrowNext
							style={{
								transform: 'rotate(180deg)',
								height: '16px',
								width: '16px',
							}}
							stroke={COLORS.secondary}
						/>
					)}
				</Stack>
			</Stack>
		</WidgetCard>
	)
}
